/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coinvestments_Dataroom_Managedatarooms4Inputs */

const en_coinvestments_dataroom_managedatarooms4 = /** @type {(inputs: Coinvestments_Dataroom_Managedatarooms4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Manage Data Rooms`)
};

/**
* | output |
* | --- |
* | "Manage Data Rooms" |
*
* @param {Coinvestments_Dataroom_Managedatarooms4Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const coinvestments_dataroom_managedatarooms4 = /** @type {((inputs?: Coinvestments_Dataroom_Managedatarooms4Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coinvestments_Dataroom_Managedatarooms4Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_coinvestments_dataroom_managedatarooms4(inputs)
});
export { coinvestments_dataroom_managedatarooms4 as "coInvestments_dataRoom_manageDataRooms" }